<template src="./html/Datatable.html"></template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	import Create from './Create'
	import Edit from './Edit'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['isAuth', 'user', 'customer'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,

			'create': Create,
			'edit': Edit,
			'loading': VueElementLoading,
		},
		created() {
			this.init()
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/collection/account/datatable',
					loading: true,
					moreParams: {
						filter: {
							text: null,
							allowDate: false,
							date: null,
							customer_id: null,
						},
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: 'id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: 'name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: 'account_holder',
							title: 'Titular',
							sortField: 'account_holder',
						},
						{
							name: 'account_number',
							title: 'Nº cuenta',
							sortField: 'account_number',
						},
						{
							name: '__slot:payment_method',
							title: 'Método de pago',
						},
						{
							name: '__slot:status',
							title: 'Estado',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},

				statuses: null,
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			filterReset() {
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			//--
			init() {
				this.getStatuses()
				if(this.customer) {
					this.datatable.moreParams.filter.customer_id = this.customer.id
				}
			},
			getStatuses() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				})
			},
			activate($event, item) {
				var toogle = $($event.target)
				toogle.addClass('disabled')
				this.$http.get('admin/management/collection/account/' + item.id + '/activate')
					.then(response => {
						toogle.removeClass('disabled')
						var data = response.body
						item.status_id = data.status_id
						item.status = data.status
					}).catch(response => {
						toogle.removeClass('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
					})
			},
			deActivate($event, item) {
				var toogle = $($event.target)
				toogle.addClass('disabled')
				this.$http.get('admin/management/collection/account/' + item.id + '/deactivate')
					.then(response => {
						toogle.removeClass('disabled')
						var data = response.body
						item.status_id = data.status_id
						item.status = data.status
					}).catch(response => {
						toogle.removeClass('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
					})
			},
			destroy: function(account) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/collection/account/' + account.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/accounts/views/Datatable.vue